<template>
  <div class="booking-box">
    <div class="step1_right">
      <div class="number mt">
        <select id="group" v-model="bookingData.area" :disabled="disable">
          <option value="886">台灣+886</option>
          <option value="852">香港+852</option>
          <option value="853">澳门+853</option>
        </select>
        <input
          type="text"
          :placeholder="placeholdText"
          v-model="bookingData.mobile"
          :disabled="disable"
          :class="[isTrueMobile ? 'color-green' : 'color-red']"
        />
      </div>
      <p class="agree mt dl">
        <!-- <input
              type="radio"
              class="radio"
              :checked="agree"
              @click="agree = !agree"
            /> -->
        <img
          src="../assets/images/ischiose.png"
          alt=""
          @click="agree = !agree"
          v-if="agree"
          class="radio"
        />
        <img
          src="../assets/images/nochiose.png"
          alt=""
          @click="agree = !agree"
          v-else
          class="radio"
        />
        同意個人資料蒐集使用及接收獎勵簡訊
      </p>
      <div
        class="Reservation_button mt"
        @click="bookingHandle"
        :class="{ disable: disable }"
      ></div>
    </div>
  </div>
</template>
<script>
import { subscribe } from "../js/api";
export default {
  name: "BookingBox",
  props: ["inviteMa"],
  data() {
    return {
      bookingData: {
        area: "886", //区号
        mobile: "", //手机号
        c: "", // 渠道
        f: "", // 邀请码
      },
      agree: true,
      disable: false,
      disabled: false,
    };
  },
  created() {
    this.bookingData.c = this.$util.getChannel(this) || "";
    this.bookingData.f = this.inviteMa || "";
    let phoneData = this.$util.getToken();
    this.bookingData.mobile = phoneData ? "您已完成預約" : "";
    this.disable = phoneData ? true : false;
  },
  mounted() {},
  methods: {
    bookingHandle() {
      // this.$bus.$emit("tips",null,"yyss");
      //设置防抖,防止多次点击
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.disable) {
          return;
        }
        if (!this.phoneNumCheck) {
          // alert("請輸入正確的手機門號");
          this.$bus.$emit("tips", "請輸入正確的手機門號");
          return;
        }
        if (!this.agree) {
          // alert("請同意協議");
          this.$bus.$emit("tips", "請同意協議");
          return;
        }

        let data = this.bookingData;
        // 请求 手机号预约
        subscribe(data).then((res) => {
          if (res.code === 1002) {
            alert(res.msg);
            // this.$bus.$emit("tips", res.msg);
            return;
          }
          this.disable = true;
          this.$util.setItem("dxzPhone", {
            mobile: data.mobile,
            area: data.area,
            giftCode: res.data.code,
            inviteCode: res.data.inviteCode,
            token: res.data.token,
          });
          this.$xmlog.register(
            null,
            "+" + this.bookingData.area + this.bookingData.mobile
          );
          this.bookingData.mobile = "您已完成預約";
          this.$bus.$emit("reGetMinfo", true); //预约成功，请求用户信息
          this.$bus.$emit("bookingAlert"); //预约成功，关闭弹窗
          this.$bus.$emit("tips", null, "yyss"); //预约成功，打开商品奖励弹窗
          this.$bus.$emit("disableBtn", "您已完成預約"); //让page2的预约按钮也不能点,并且复制语句
          document
            .getElementsByClassName("colorinput")[0]
            .classList.add("colortrue");
        });
      }, 200);
    },
  },
  computed: {
    phoneNumCheck() {
      let area = this.bookingData.area;
      let phone = this.bookingData.mobile;
      if (area === "886") {
        //台湾
        return /^(0?9\d{8})$/.test(phone);
      } else if (area === "852") {
        // 香港
        return /(^\d{8})$/.test(phone);
      } else {
        //澳门
        return /^([6]\d{7})$/.test(phone);
      }
    },
    placeholdText() {
      let text = "";
      switch (this.bookingData.area) {
        case "886":
          text = "9xxxxxxxx（共9位）";
          break;
        case "852":
          text = "xxxxxxxx（共8位）";
          break;
        case "853":
          text = "6xxxxxxx（共8位）";
          break;
      }
      return text;
    },
    isTrueMobile() {
      let reg;
      switch (this.bookingData.area) {
        case "886":
          reg = new RegExp(/^9\d{8}$/);
          break;
        case "852":
          reg = new RegExp(/^\d{8}$/);
          break;
        case "853":
          reg = new RegExp(/^6\d{7}$/);
          break;
      }
      return reg.test(this.bookingData.mobile);
    },
  },
};
</script>
<style lang="less" scoped>
.booking-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: url("../assets/images/toast.png") no-repeat;
  position: relative;
  background-size: 100% 100%;
  position: relative;
  padding: 3.7rem 1rem 0 1rem;
  .step1_right {
    .number {
      text-align: left;
      display: flex;
      height: 0.8rem;
      padding: 0.2rem;
      background: url("../assets/images/inputbg.png") no-repeat;
      background-size: 100% 100%;
      select {
        border: none;
        background: transparent;
        color: #000612;
        font-size: 0.24rem;
        option {
          background: #fff;
        }
      }
      input {
        padding: 0;
        width: 100%;
        padding-left: 0.1rem;
        height: 0.54rem;
        border: none;
        height: 100%;
        border-left: 0.02px solid #000612;
        background: transparent;
        color: red;
        border-radius: 0;
        font-size: 0.24rem;
        &::placeholder {
          color: #000612;
        }
      }
      .color-green {
        color: green;
      }
      .color-red {
        color: red;
      }
    }
    .Reservation_button {
      width: 100%;
      height: 1.5rem;
      background: url("../assets/images/immediately_yy2.png") no-repeat;
      background-position: center;
      background-size: cover;
      // font-size: 0.5rem;
      // border: 1px solid #000;
      cursor: pointer;
      margin-left: auto;
    }
    .disable {
      cursor: no-drop;
      filter: grayscale(100%);
    }
    .agree {
      font-size: 0.25rem;
      justify-content: center;
      position: relative;
      .radio {
        margin: 0;
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
